import client from './client';

export const vmCvesApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/vm/cves', { params });
    return data;
  },

  async get(cveId) {
    const { data } = await client.get(`/api/vm/cves/${encodeURIComponent(cveId)}`);
    return data;
  },

  async triageAll(cveId) {
    const { data } = await client.post(`/api/vm/cves/${encodeURIComponent(cveId)}/triage-all`);
    return data;
  },
};
